import React from 'react';
import { adaptEventHandler } from '../../utils';
import { default as PlatformComment, CommentAuthor, CommentEdited, CommentTime, CommentAction } from '@atlaskit/comment';

// Public API - hand-picked subset of the following props:

// Omit for overriding props that are React components

export var Comment = function Comment(props) {
  var _ref = props.forgeDoc.props,
    actions = _ref.actions,
    afterContent = _ref.afterContent,
    author = _ref.author,
    edited = _ref.edited,
    errorActions = _ref.errorActions,
    errorIconLabel = _ref.errorIconLabel,
    headingLevel = _ref.headingLevel,
    highlighted = _ref.highlighted,
    id = _ref.id,
    isError = _ref.isError,
    isSaving = _ref.isSaving,
    restrictedTo = _ref.restrictedTo,
    savingText = _ref.savingText,
    shouldRenderNestedCommentsInline = _ref.shouldRenderNestedCommentsInline,
    testId = _ref.testId,
    time = _ref.time,
    type = _ref.type;
  var avatarForgeDoc = props.forgeDoc.children.find(function (child) {
    var _child$props;
    if (child.type === 'ContentWrapper' && ((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.name) === 'avatar') {
      return child;
    }
  });
  var contentForgeDoc = props.forgeDoc.children.find(function (child) {
    var _child$props2;
    if (child.type === 'ContentWrapper' && ((_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.name) === 'content') {
      return child;
    }
  });
  return /*#__PURE__*/React.createElement(PlatformComment, {
    actions: actions === null || actions === void 0 ? void 0 : actions.map(function (action, index) {
      return /*#__PURE__*/React.createElement(CommentAction, {
        key: index,
        onClick: adaptEventHandler(action === null || action === void 0 ? void 0 : action.onClick)
      }, action.text);
    }),
    afterContent: afterContent,
    author: author ? /*#__PURE__*/React.createElement(CommentAuthor, {
      onClick: adaptEventHandler(author === null || author === void 0 ? void 0 : author.onClick)
    }, author.text) : undefined,
    avatar: avatarForgeDoc === null || avatarForgeDoc === void 0 ? void 0 : avatarForgeDoc.children.map(props.render),
    children: props.forgeDoc.children.filter(function (child) {
      return child.type !== 'ContentWrapper';
    }).map(function (c) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: c.key
      }, props.render(c));
    }),
    content: contentForgeDoc === null || contentForgeDoc === void 0 ? void 0 : contentForgeDoc.children.map(props.render),
    edited: edited ? /*#__PURE__*/React.createElement(CommentEdited, null, edited) : undefined,
    errorActions: errorActions === null || errorActions === void 0 ? void 0 : errorActions.map(function (action, index) {
      return /*#__PURE__*/React.createElement(CommentAction, {
        key: index,
        onClick: adaptEventHandler(action === null || action === void 0 ? void 0 : action.onClick)
      }, action.text);
    }),
    errorIconLabel: errorIconLabel,
    headingLevel: headingLevel,
    highlighted: highlighted,
    id: id,
    isError: isError,
    isSaving: isSaving,
    restrictedTo: restrictedTo,
    savingText: savingText,
    shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline,
    testId: testId,
    time: time ? /*#__PURE__*/React.createElement(CommentTime, {
      onClick: adaptEventHandler(time === null || time === void 0 ? void 0 : time.onClick)
    }, time.text) : undefined,
    type: type
  });
};